import Vue from "vue";
import Button from "./ui/atoms/button/Button.vue";
import { dateTimeFilter, timeFilter } from "./ui/filters/dateTimeFilters";


Vue.component("Button", Button);
Vue.filter("time", timeFilter);
Vue.filter("dateTime", dateTimeFilter);
